/* globals document, window */
import React, { Fragment } from "react";
import GlobalAlert from "../common/GlobalAlert";
import ContactForm from "./ContactForm";
import Testimonials from "../common/Testimonials";

import { GlobalProvider } from "../common/GlobalContext";

type Props = {
  alerts: Array<Object>,
  compliance: Object,
  favorites: Array<number>,
  previousFormFieldValues: Object,
  RECAPTCHA_CLIENT: string,
  RECAPTCHA_CLIENT_V2: string,
  siteUser: Object,
  testimonials: Array<Object>,
  theme: Object, // theme from the API/site settings, not the react-jss theme
};

const Contact = ({
  alerts,
  compliance,
  favorites,
  previousFormFieldValues,
  RECAPTCHA_CLIENT,
  RECAPTCHA_CLIENT_V2,
  siteUser,
  testimonials,
  theme,
}: Props) => {
  return (
    <GlobalProvider
      compliance={compliance}
      favorites={favorites}
      siteUser={siteUser}
      theme={theme}
      RECAPTCHA_CLIENT={RECAPTCHA_CLIENT}
      RECAPTCHA_CLIENT_V2={RECAPTCHA_CLIENT_V2}
    >
      <Fragment>
        <GlobalAlert alerts={alerts} />
        <ContactForm previousFormFieldValues={previousFormFieldValues} />
        <Testimonials testimonials={testimonials} />
      </Fragment>
    </GlobalProvider>
  );
};

export default Contact;
